import { request } from '@/utils/request'


export function studyPaperDelete( params ) {
  return request({
    url: '/base/studyPaper/delete',
    method: 'delete',
    headers: {
      'Device-Type': 'app' 
    },
    params
  })
}
// 重置答题列表
export function studyRecordRenew( data ) {
  return request({
    url: '/base/studyRecord/renew',
    method: 'post',
    headers: {
      'Device-Type': 'app' 
    },
    data
  })
}
export function getTree(token,params) {
  return request({
    url: '/base/studyRecord/getByStudyCategory',
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 刷题答题卡
export function answerSheet(data) {
  return request({
    url: `/base/studyRecord/answerSheet`,
    method: 'post',
    data,
    headers: {
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 错题答题卡
export function wrongAnswerSheett(data) {
  return request({
    url: `/base/studyRecord/wrongAnswerSheet`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 收藏答题卡
export function resourceAnswerSheet(data) {
  return request({
    url: `/base/studyRecord/resourceAnswerSheet`,
    method: 'post',
    data,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}


// 刷题的题目
export function getQuestions(data) {
  return request({
    url: '/base/studyQuestionRecord/getPracticeQuestions',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 错题的题目
export function getWrongAnswerQuestions(data) {
  return request({
    url: '/base/studyQuestionRecord/getWrongAnswerQuestions',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 答题
export function addQuestion(data) {
  return request({
    url: '/base/studyRecord/add',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 组卷答题
export function addQuestionResult(data) {
  return request({
    url: `/base/studyPaper/questionResult/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 新增学习笔记
export function addQuestionResource(data) {
  return request({
    url: `/base/questionResource/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 查询收藏-笔记题目
export function getQuestionsList(data) {
  return request({
    url: `/base/studyQuestionRecord/getResourceQuestions`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 查询全部学习笔记
export function questionResourceList(params) {
  return request({
    url: `/base/questionResource/list`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 智能组题表
export function studyPaperPage(params) {
  return request({
    url: `/base/studyPaper/page`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 查询符合条件的题目数量
export function getNum(params) {
  return request({
    url: `/base/studyPaper/getQuestionNum`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 新增智能组题
export function addAnswer(data) {
  return request({
    url: `/base/studyPaper/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}


// 智能组题答题卡
export function combinationAnswerSheet(studyPaperId) {
  return request({
    url: `/base/studyPaper/answerSheet/${studyPaperId}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 根据id查询智能组题表
export function studyPaperGetById(studyPaperId,params) {
  return request({
    url: `/base/studyPaper/getById/${studyPaperId}`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 获取问题详情
export function getOneQuestionId(majorType,questionId) {
  return request({
    url: `/base/studyQuestionRecord/getOnePracticeQuestion/${majorType}/${questionId}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 商品基本信息
export function getById(id) {
  return request({
    url: `/base/product/info/getById/${id}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}